<template>
    <div class="row">
        <div class="col-12 col-xl-9">
            <div class="state_tracker--simple">
                <div class="row">
                    <div class="col-4 col-sm-4 col-md-3">
                        <div class="state_tracker__item" :class="{'active': atTitle}">
                            <div class="state_tracker__indicator">
                                <div class="state_tracker__indicator--number">
                                    1
                                </div>
                            </div>
                            <div class="state_tracker__item__info">
                                <p><strong>{{$t('support.wizard.state_where')}}</strong></p>
                                <p class="state_tracker__item__info__description">
                                    {{$t('support.wizard.state_where_sub')}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1 hidden-xs"></div>
                    <div class="col-4 col-sm-4 col-md-4">
                        <div class="state_tracker__item" :class="{'active': atDetail}">
                            <div class="state_tracker__indicator">
                                <div class="state_tracker__indicator--number">
                                    2
                                </div>
                            </div>
                            <div class="state_tracker__item__info">
                                <p><strong>{{$t('support.wizard.state_what')}}</strong></p>
                                <p class="state_tracker__item__info__description">
                                    {{$t('support.wizard.state_what_sub')}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1 hidden-xs"></div>
                    <div class="col-4 col-sm-4 col-md-3">
                        <div class="state_tracker__item" :class="{'active': atAppointment || atPosted}">
                            <div class="state_tracker__indicator">
                                <div class="state_tracker__indicator--number">
                                    3
                                </div>
                            </div>
                            <div class="state_tracker__item__info">
                                <p><strong>{{$t('support.wizard.state_send_request')}}</strong></p>
                                <p class="state_tracker__item__info__description">
                                    {{$t('support.wizard.state_send_request_sub')}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import {STAGE_TITLE, STAGE_DETAIL, STAGE_APPOINTMENT, STAGE_POSTED} from './stages';

    @Component
    export default class WizardStateTracker extends Vue {
        @Prop({type: Number, default: STAGE_TITLE})
        stage;

        get atTitle() {
            return this.stage === STAGE_TITLE;
        }
        get atDetail() {
            return this.stage === STAGE_DETAIL;
        }
        get atAppointment() {
            return this.stage === STAGE_APPOINTMENT;
        }
        get atPosted() {
            return this.stage === STAGE_POSTED;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/support/WizardStateTracker.vue